import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2)

const dialogButtons = {
  confirmButtonText: 'ตกลง',
  customClass: {
    confirmButton: 'btn btn-primary',
  },
  buttonsStyling: false,
}

Vue.prototype.$notifyDialog = function notifyDialog({
  icon = 'info',
  title = '',
  text = '',
} = {}) {
  return this.$swal({
    icon,
    title,
    text,
    ...dialogButtons,
  })
}

Vue.prototype.$notifyRequired = function notifyRequired(text) {
  return this.$notifyDialog({
    icon: 'warning',
    title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
    text: text || 'โปรดตรวจสอบช่องที่จำเป็นก่อนบันทึก',
  })
}

const style = document.createElement('style')
style.innerHTML = '.swal2-container { z-index: 20000 !important; }'
document.head.appendChild(style)
